import * as React from 'react';
import { AdminDetail } from 'Interfaces/Admin';
import GroupForm from '../GroupForm';
import UserForm from '../UserForm';
import CampaignForm from '../CampaignForm';
import Activity from '../Activity';
import AccessLogs from '../AccessLogs';

interface Props {
  detail: AdminDetail;
}

/**
 *  Renders whatever the detail pane is currently showing. The legacy tool put
 *  these in #detailsContainer or, when something was selected, as the rightmost
 *  panel of the column stack.
 */
export default function DetailPane(props: Props) {
  const { detail } = props;
  switch (detail.kind) {
    case 'group':
      return <GroupForm groupId={detail.id} />;
    case 'user':
      return <UserForm userId={detail.id} />;
    case 'campaign':
      return <CampaignForm campaignId={detail.id} />;
    case 'activity':
      return <Activity />;
    case 'accessLogs':
      return <AccessLogs />;
    default:
      return null;
  }
}
